import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=bdc6b7da&scoped=true&"
import script from "./Metrics.vue?vue&type=script&lang=ts&"
export * from "./Metrics.vue?vue&type=script&lang=ts&"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=bdc6b7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc6b7da",
  null
  
)

export default component.exports